export default "__VITE_ASSET__DFzXMZGL__"